import type { AppointmentBrief } from '../api/types';
import { cleanAiText } from './aiText';

// briefRows: Zeilen der Terminvorbereitung in fester Reihenfolge – leere weglassen und Texte, die schon in einer
// früheren Zeile stehen, nicht wiederholen (die KI schreibt denselben Satz oft unter Bedarf, Motivation und Besonderheiten).
// skip: Zeilen, die die Seite schon an anderer Stelle zeigt (Terminseite: Gespräch steht in „Auf einen Blick“, der letzte
// Kontakt unter „Bisherige Kontakte“).
export function briefRows(b: AppointmentBrief, skip: string[] = []): [string, string][] {
  const rows: [string, string][] = [
    ['Gespräch', cleanAiText(b.summary)],
    ['Interesse', b.interest],
    ['Bedarf', b.needs.join(' · ')],
    ['Motivation', b.motivation],
    ['Einwände', b.objections.join(' · ')],
    ['Ziel', b.desired_outcome],
    ['Besonderheiten', b.specials.join(' · ')],
    ['Offene Fragen', b.open_questions.join(' · ')],
    ['Letzter Kontakt', b.last_contact],
  ];
  const seen: string[] = [];
  // Vergleich ohne vorangestellte Kennung („Einwand: …“, „Objekt laut Gespräch: …“): steckt der Text schon in einer früheren
  // Zeile, wird er nicht wiederholt.
  const norm = (t: string) => t.trim().toLowerCase().replace(/^[a-zäöü ]{3,30}:\s*/, '').replace(/[.\s]+$/, '');
  return rows.filter(([label, text]) => {
    if (skip.includes(label)) return false;
    const key = norm(text);
    if (!key || seen.some((s) => s === key || (key.length > 20 && s.includes(key)))) return false;
    seen.push(key);
    return true;
  });
}
